import AjaxURL from '../AjaxURL';

/* global addToBagV2*/
function deleteProductAlert(target) {
  /* Liste des paramètres = {idProduct} */
  $(target).on('click', (e) => {
    const param = $(e.currentTarget).data('param');
    $.ajax({
      type: 'POST',
      dataType: 'json',
      url: AjaxURL.deleteSubscription,
      data: {
        task: 'deleteSubscription',
        idProduct: param.idProduct,
      },
      success(data) {
        $(`#${data.id}`).remove();
        if ($('#product_list_container').length === 0) {
          window.location.reload();
        }
      },
    });
  });
}

function addToBagCRMMyAlerts(target) {
  /* Liste des paramètres = {aoTarget, sku, id, qty, idCountry, idLang, gotobag,
   * showpopup, productTitle, productImage, productPrice} */
  $(target).on('click', (e) => {
    const param = $(e.currentTarget).data('param');
    const selects = $(param.aoTarget)
     .parents('.product_list_lastColumn')
     .siblings('.product_list_qt')
     .find('.basic_select select[data-og-id="qty"]');

    let newQty = param.qty;
    if (selects.length) {
      newQty = $(selects[0]).val();
    }

    addToBagV2(param.sku, param.id, newQty, param.idCountry, param.idLang, param.gotobag,
       param.showpopup, param.productTitle, param.productImage, param.productPrice);
  });
}

/**
 * Associate SKU references with an isInStock boolean.
 * @param  {Array} An array of SKU's.
 * @return {Object} Return an object with SKU as properties.
 */
function checkStock(skuList, callback) {
  const skuArgs = skuList;
  const dataObj = { task: 'getstockstatus' };

  if (skuArgs.length > 1) {
    dataObj.SKUS = skuArgs.join(',');
  } else if (skuArgs.length === 1) {
    dataObj.SKU = skuArgs[0];
  }

  $.ajax({
    type: 'POST',
    dataType: 'json',
    url: AjaxURL.checkStocks,
    data: dataObj,
    success(data) {
      if (typeof callback === 'function') {
        callback(data.data);
      }
    },
  });
}

export {
    addToBagCRMMyAlerts,
    deleteProductAlert,
    checkStock,
};



// WEBPACK FOOTER //
// ./js/common/organism/out-of-stock.js